import React, { useEffect, useRef, useState } from "react";
import "./Whatwedo.css";

/**
 * WHAT WE DO section
 * - Soft background image (Pexels – massage theme)
 * - 3 service cards with text only (icons removed)
 * - Small underline under each title
 * - Responsive: 3 → 2 → 1 columns
 * - Montserrat font
 */

const Services = [
  {
    title: "Swedish Massage",
    desc:
      "A gentle, relaxing full-body massage that promotes overall relaxation and improves circulation using long, flowing strokes.",
  },
  {
    title: "Deep Tissue Massage",
    desc:
      "Targets deeper layers of muscle and connective tissue to release chronic tension and muscle knots.",
  },
  {
    title: "Cupping Therapy",
    desc:
      "Use of silicone cups or plastic cups with suction applied to the tissue creating suction of soft tissue, helps with pain, tightness, inflammation, blood flow and relaxation.",
  },
];

export default function Whatwedo() {
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef(null);
  const cardsRef = useRef([]);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.1 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => observer.disconnect();
  }, []);

  const addToCardsRef = (el) => {
    if (el && !cardsRef.current.includes(el)) {
      cardsRef.current.push(el);
    }
  };

  return (
    <section 
      className="wwd" 
      id="services" 
      aria-labelledby="wwd-title"
      ref={sectionRef}
    >
      {/* Animated background elements */}
      <div className="wwd__bg-pattern" aria-hidden="true">
        <div className="wwd__bg-shape wwd__bg-shape--1"></div>
        <div className="wwd__bg-shape wwd__bg-shape--2"></div>
        <div className="wwd__bg-shape wwd__bg-shape--3"></div>
      </div>

      {/* Decorative background image (Pexels) */}


      <div className="wwd__container">
        {/* Heading block */}
        <div className={`wwd__head ${isVisible ? 'is-visible' : ''}`}>
          <h2 id="wwd-title" className="wwd__title">
            <span className="wwd__title-line">How We Care</span>
            <span className="wwd__title-line wwd__title-line--accent">For You</span>
          </h2>
          <div className="wwd__rule" aria-hidden="true">
            <div className="wwd__rule-line"></div>
            <div className="wwd__rule-dot"></div>
            <div className="wwd__rule-line"></div>
          </div>
          <p className="wwd__intro">
            You deserve expert massage care in a calm, comfortable setting designed for true relaxation.
          </p>
        </div>

        {/* Cards - Icons removed, with title underline */}
        <div className="wwd__grid">
          {Services.map(({ title, desc }, i) => (
            <article 
              className={`wwd-card ${isVisible ? 'is-visible' : ''}`} 
              key={i}
              ref={addToCardsRef}
              style={{ animationDelay: `${i * 0.2}s` }}
            >
              <div className="wwd-card__glow" aria-hidden="true"></div>
              <div className="wwd-card__inner">
                <h3 className="wwd-card__title">
                  {title}
                  <span className="wwd-card__title-underline" aria-hidden="true"></span>
                </h3>
                <p className="wwd-card__desc">{desc}</p>
              </div>
            </article>
          ))}
        </div>

        {/* CTA */}
        <div className={`wwd__cta ${isVisible ? 'is-visible' : ''}`}>
          <a className="wwd__btn" href="/services" aria-label="View all services">
            <span className="wwd__btn-text">VIEW ALL SERVICES</span>
            <div className="wwd__btn-icon">
              <svg viewBox="0 0 24 24" width="20" height="20">
                <path d="M9 18l6-6-6-6" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </div>
            <div className="wwd__btn-shine"></div>
          </a>
        </div>
      </div>
    </section>
  );
}